module.exports = __webpack_public_path__ + "img/SetIt.ef123517.png";